<div class="d-flex flex-column vh-100">
    <static-hdr></static-hdr>

    <section class="container flex-grow-1">
        <div class="card card-custom h-100">
            <div class="card-body">
                <h1 class="font-weight-bold text-primary mb-7 mt-15">{{'News'|localize}}</h1>

                <p-dataView #dv [value]="newsList" [paginator]="true" [rows]="10" [loading]="Loading"
                    [emptyMessage]="l('NoData')" [lazy]="true" (onLazyLoad)="loadNews($event)"
                    (onPage)="loadNews($event)" [totalRecords]="TotalNewsCount" layout="list">
                    <ng-template let-newsView pTemplate="listItem">
                        <news-list-item [newsitemView]="newsView">

                        </news-list-item>
                    </ng-template>

                </p-dataView>
            </div>
            <div class="card-footer d-flex justify-content-between">
                <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
                    {{l('Back')}} </button>
            </div>
        </div>
    </section>

    <static-ftr></static-ftr>
</div>
